const formEvents = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-form-events]').forEach((form) => {
            const formElement = form as HTMLFormElement;
            const repeatMailInput = formElement.querySelector('#email-repeat') as HTMLInputElement;
            const mailInput = formElement.querySelector('#email') as HTMLInputElement;

            repeatMailInput.addEventListener('change', function (event : any) {
                const mailInputValue = mailInput.value;
                const repeatMailInputValue = repeatMailInput.value;
                if (mailInputValue !== repeatMailInputValue) {
                    event.target.setCustomValidity('Die E-Mail Adressen stimmen nicht überein');
                } else {
                    event.target.setCustomValidity('');
                }
                event.target.reportValidity();
            });

            formElement.addEventListener('submit', async (event) => {
                event.preventDefault();
                try {
                    const responseToken = await fetch('/wp-json/gg/token-events', {
                        method: 'GET'
                    });
                    if (!responseToken.ok) throw new Error();
                    const tokenData = await responseToken.json();
                    const token = Number(tokenData.token) as number;
                    const generatedToken = token + 23;
                    const dataGeneratedTokenElem = formElement.querySelector('[data-generated-token]') as HTMLInputElement;
                    dataGeneratedTokenElem.setAttribute('value', String(generatedToken));
                    const formData = new FormData(formElement);
                    const response = await fetch('/wp-json/gg/form-events/', {
                        method: 'POST',
                        body: formData
                    });
                    const data = await response.json();
                    if (!response.ok) throw new Error();
                    if (data===true) {
                        const formErrorElement = document.querySelector("#form-error") as HTMLElement;
                        formErrorElement.style.display = "none";
                        const formSuccessElement = document.querySelector("#form-success") as HTMLElement;
                        formSuccessElement.style.display = "block";
                        formSuccessElement.scrollIntoView({block:"center",behavior: 'smooth'});
                    } else {
                        throw new Error();
                    }
                } catch (error) {
                    const formSuccessElement = document.querySelector("#form-success") as HTMLElement;
                    formSuccessElement.style.display = "none";
                    const formErrorElement = document.querySelector("#form-error") as HTMLElement;
                    formErrorElement.style.display = "block";
                    formErrorElement.scrollIntoView({block:"center",behavior: 'smooth'});
                }
            });
        });
    });
}

export { formEvents }